import GithubIcon from '../icons/GithubIcon'
import './buttons.css'

export default function GithubButton() {
  return (
    <a
      href="https://github.com/cosminpm"
      target="_blank"
      rel="noopener noreferrer"
      className="button-link github"
    >
      <GithubIcon className="icon" /> GitHub
    </a>
  )
}
